import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './styles.scss';

const ID = 'component-activity-indicator';
const LEAFS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12];

ActivityIndicator.propTypes = {
  size: PropTypes.oneOf(['small', 'large']),
  color: PropTypes.string
};

ActivityIndicator.defaultProps = {
  size: 'small',
  color: '#ffffff'
};

export default function ActivityIndicator(props) {
  const {
    size, className, color, ...reset
  } = props;
  const cls = classnames(ID, `${ID}-${size}`, className);

  return (
    <div className={cls} {...reset}>
      {LEAFS.map((item, index) => {
        const key = `${index}`;
        return (<div key={key} style={{ backgroundColor: color }} />);
      })}
    </div>
  );
}
